@if (loadSpinner) {
<div class="loading-container">
    <kendo-loader type="converging-spinner"></kendo-loader>
</div>
}
<kendo-dialog-titlebar>
    <h4 class="k-m-0" style="color: var(--tb-kendo-neutral-160)">Complete Action Item</h4>
</kendo-dialog-titlebar>

<!-- Action Item Details section -->
<div class="action-required-container section">
    <h4 class="section__heading">Action Required: {{actionDetails?.name}}</h4>
    <div class="action-item-container">
        <div>
            <p class="secondary-small-text">Status</p>
            <p>{{getStatus(actionDetails?.status)}}</p>
        </div>
        <div>
            <p class="secondary-small-text">Action Item ID</p>
            <p>{{actionDetails?.id}}</p>
        </div>
        <div>
            <p class="secondary-small-text">IHMS Case No</p>
            <p>{{actionDetails?.ihmsCaseNo}}</p>
        </div>
        <div>
            <p class="secondary-small-text">Type</p>
            <p>{{actionDetails?.type}}</p>
        </div>
        <div>
            <p class="secondary-small-text">Assignee</p>
            <p>{{actionDetails?.assigneeName}}</p>
        </div>
        <div>
            <p class="secondary-small-text">Due Date</p>
            <p>{{actionDetails?.dueDate | formatDate}}</p>
        </div>
    </div>
    <div>
        <p class="secondary-small-text">Details</p>
        <p>{{actionDetails?.details}}</p>
    </div>
</div>

<!-- Completed Event Section -->
<div class="k-mt-12 event-section">
    <div class="section">
        <h4 class="section__heading">Completed Events</h4>
        <p>Please select and add any completed events that relate to this action item. You may use the
            column filters to
            search if needed.</p>
    </div>
    <kendo-grid [kendoGridBinding]="completedEvents" [pageSize]="10" [pageable]="{
                pageSizes: [5, 10, 20],
            }" [columnMenu]="{filter:true, columnChooser:false, sort:true}" [filterable]="false" [sortable]="false"
        [loading]="ihmsService.loadingEvents">
        <kendo-grid-column field="Type" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <p> {{ dataItem?.eventType }}
                </p>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Date/Time Occurred" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <p>{{ dataItem?.dateTimeOccurred | date: 'MM/dd/yyyy HH:mm'}}</p>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Subject" [width]="400">
            <ng-template kendoGridCellTemplate let-dataItem>
                <p class="k-white-space-normal k-m-0">{{ dataItem?.eventSubject }}</p>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Logged By" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <p>{{ dataItem?.loggedBy }}</p>
                <span class="font-12">{{ dataItem?.loggedBy?.timestamp }}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Actions" [width]="100" headerClass="action-column" [filterable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
                <button kendoButton themeColor="primary" fillMode="solid" (click)="addEvent(dataItem)"
                    [disabled]="isEventAlreadyAdded(dataItem)">{{ isEventAlreadyAdded(dataItem) ? 'Added' : 'Add'
                    }}</button>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>

<div class="divider"></div>

<!-- Added Events Section -->
<div class="subsection event-section">
    <h5 class="subsection__subheading">Added Events</h5>
    <kendo-grid [kendoGridBinding]="addedEvents" #addedEventsGrid [pageSize]="10" [pageable]="{
                pageSizes: [5, 10, 20],
            }" [columnMenu]="{filter:true, columnChooser:false, sort:true}"
        [selectable]="{ mode: 'multiple', checkboxOnly: true }" (selectionChange)="onSelectionChange($event)"
        [(selectedKeys)]="mySelection" kendoGridSelectBy="outreachSk">
        <kendo-grid-checkbox-column [width]="50" [showSelectAll]="true">
        </kendo-grid-checkbox-column>
        <kendo-grid-column field="Type">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.eventType }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Date/Time Occurred">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.dateTimeOccurred | date: 'MM/dd/yyyy HH:mm'}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Subject">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.eventSubject }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Logged By">
            <ng-template kendoGridCellTemplate let-dataItem>
                <p>{{ dataItem?.loggedBy }}</p>
                <!---Dev Note: Backend Dev Confirmed No Data Available for Timestamp, Once Available please uncomment below line---->
                <!-- <span class="font-12">{{ dataItem?.timestamp }}</span> -->
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
    <div class="k-d-flex k-justify-content-start">
        <button kendoButton themeColor="error" fillMode="outline" [disabled]="!mySelection?.length"
            (click)="removeSelectedEvents()">Remove
            Selected Events</button>
    </div>
</div>

@if (addedEvents?.length) {
<div class="warning-banner k-col-span-full !k-mx-0">
    <p class="k-m-0" style="color:#BD0026"><fa-icon icon="triangle-exclamation" class="k-mr-2"
            size="lg"></fa-icon><strong>Completing this
            action item
            is
            irreversible.</strong></p>
    <p class="k-m-0 k-ml-7">Please review and confirm that all relevant completed events have been added.</p>
</div>
}

<kendo-dialog-actions>
    <div class="k-d-flex k-justify-content-end">
        <button kendoButton themeColor="primary" fillMode="solid" [disabled]="!addedEvents?.length"
            (click)="completeEvent()">Complete Action
            Item</button>
    </div>
</kendo-dialog-actions>